import pipe1 from "../../slike/pipe1.png";
import slika2 from "../../slike/ADSSADAS.png";
import slika3 from "../../slike/PIPE.png";
import slika4 from "../../slike/2.png";
import './Download.css'
export default function Download() {
    const handleDownload = (name) => {
        const pdfUrl = "/"+name+".pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = name+".pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
    const products=[
        {slika:pipe1,naslov:"KARAKURI SYSTEM",link:"/"},
        {slika:slika2,naslov:"SQUARE PROFILES",link:"/"},
        {slika:slika3,naslov:"LEAN TUBE SYSTEM",link:"/"},
        {slika:slika4,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"}
      ]
  return (
    <div className='downloadPage'>
      <div className="C">
        <div className='homeC'>
            <p>Catalogs</p>
        </div>
      </div>

      <div className='productsContainer'>
        <p className='h2'>DOWNLOAD CATALOGS</p>
      </div>
      <div className='s'>
        {products.map((item,index)=>(
            <div className='okvir' onClick={()=>{handleDownload(item.naslov.toLocaleLowerCase())}}>
              <div className='productBox'>
                <img src={item.slika} className='slika' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          ))}
      </div>
    </div>
  )
}